export default "__VITE_ASSET__CwJwHdg7__"